import { render, staticRenderFns } from "./ClientBalanceReport.vue?vue&type=template&id=a3a711ae&"
import script from "./ClientBalanceReport.vue?vue&type=script&lang=js&"
export * from "./ClientBalanceReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ClientBalanceReport.vue?vue&type=custom&index=0&blockType=messages"
if (typeof block0 === 'function') block0(component)

export default component.exports